import styled from 'styled-components';
import { Paper } from '@mui/material';

export const ContentPaper = styled(Paper)`
  padding: 24px;
  min-height: 400px;
  
  @media (max-width: 600px) {
    padding: 16px;
  }
`;
